import ServiceResultSchema, { ServiceResult } from '../schemas/ServiceResultSchema'

export default function ServiceResultVo(initData: unknown = {}): ServiceResult | undefined {
  try {
    return ServiceResultSchema.validateSync(initData)
  } catch (e) {
    console.error(e)
  }
}
